import Header from './components/Header';
import Hero from './components/Hero';
import SectionIndex from './components/SectionIndex';
import SectionMedia from './components/SectionMedia';
import SectionApp from './components/SectionApp';
import SectionFeatures from './components/SectionFeatures';
import SectionRanking from './components/SectionRanking';
import SectionFAQ from './components/SectionFAQ';
import SectionContact from './components/SectionContact';
import SectionTopics from './components/SectionTopics';
import SectionUpdates from './components/SectionUpdates';
import SectionAbout from './components/SectionAbout';
import SectionComments from './components/SectionComments';
import SectionCarousel from './components/SectionCarousel';
import SectionCards from './components/SectionCards';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-200">
      <Header />
      <main>
        <Hero />
        <SectionIndex />
        <SectionMedia />
        <SectionApp />
        <SectionFeatures />
        <SectionRanking />
        <SectionFAQ />
        <SectionContact />
        <SectionTopics />
        <SectionUpdates />
        <SectionAbout />
        <SectionComments />
        <SectionCarousel />
        <SectionCards />
      </main>
      <Footer />
    </div>
  );
}